import { render } from "./DeliveryReport.vue?vue&type=template&id=aaf376be&scoped=true"
import script from "./DeliveryReport.vue?vue&type=script&lang=js"
export * from "./DeliveryReport.vue?vue&type=script&lang=js"

import "./DeliveryReport.vue?vue&type=style&index=0&id=aaf376be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf376be"]])

export default __exports__